import type { TimeRange } from '@brighterly/lib-core-types/activation/enums'

import { DateFormat } from '@brighterly/lib-core-types/date/enums'
import { ShortDaysOfWeek } from '@brighterly/lib-core-types/options/enums'

import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

import { useWeekList } from '@shared/lib/format'
import { formatSlotTime } from '@shared/lib/format'
import { isFullArray } from '@shared/lib/collections'

dayjs.extend(utc)
dayjs.extend(timezone)

export const getInitialScheduleData = (): Record<ShortDaysOfWeek, TimeRange[]> => {
  return {
    [ShortDaysOfWeek.Sunday]: [],
    [ShortDaysOfWeek.Monday]: [],
    [ShortDaysOfWeek.Tuesday]: [],
    [ShortDaysOfWeek.Wednesday]: [],
    [ShortDaysOfWeek.Thursday]: [],
    [ShortDaysOfWeek.Friday]: [],
    [ShortDaysOfWeek.Saturday]: [],
  }
}

export const isSchedulesEqual = (
  schedule1: Record<ShortDaysOfWeek, TimeRange[]>,
  schedule2: Record<ShortDaysOfWeek, TimeRange[]>,
): boolean => {
  for (const day of useWeekList().weekList) {
    const slots1 = schedule1[day] || []
    const slots2 = schedule2[day] || []
    if (slots1.length !== slots2.length) return false

    const sorted1 = [...slots1].sort((a, b) => (a.from + a.to).localeCompare(b.from + b.to))
    const sorted2 = [...slots2].sort((a, b) => (a.from + a.to).localeCompare(b.from + b.to))

    for (let i = 0; i < sorted1.length; i++) {
      if (sorted1[i]!.from !== sorted2[i]!.from || sorted1[i]!.to !== sorted2[i]!.to) {
        return false
      }
    }
  }
  return true
}

export const getScheduleDetails = (slots: TimeRange[]): string => {
  const date = dayjs().format(DateFormat.DefaultDate)
  const list = slots.map(slot => `${formatSlotTime(`${date} ${slot.from}`)}`)
  return isFullArray(list) ? `${list.join(', ')};` : ''
}
